import React, {FC, lazy, Suspense, useState} from 'react';
import {Section as Query} from 'templates/reports/query';
import {BarChartProps} from 'templates/reports/Section/Charts/BarChart';
import {Section as Config} from 'templates/reports/types';

import Selector from './Selector';

import * as styles from './styles.module.scss';

const LazyChart = lazy(() => import('templates/reports/Section/Charts/BarChart'));

const DynamicChart: FC<BarChartProps> = (props) => (
	<Suspense fallback={null}>
		<LazyChart {...props} />
	</Suspense>
);

type SnapshotProps = {
	chart: (result: number) => BarChartProps
	cfgs: Config['details']['snapshot']
	children: React.ReactNode
	data: Query
};

const Snapshot: FC<SnapshotProps> = ({chart, cfgs, data, children}) => {
	const [index, setIndex] = useState(0);
	return (
		<div className={styles.wrapper}>
			<div className={styles.header}>
				<h2>
					Your {cfgs.text.metric} compared
					to <em>{cfgs.text.reference}</em>
				</h2>
				<Selector
					results={data.results}
					onSelect={setIndex}
				/>
			</div>
			<p>{cfgs.text.explainer}</p>
			<DynamicChart
				{...chart(index)}
				className={styles.chart}
			/>
			{children}
		</div>
	);
};

export default Snapshot;
